import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import { sectionPaddingClasses } from '../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers';

export default function SingleMediaSlice(props) {

    const {
        title,
        description,
        button_title,
        button_url,
        image,
        image_alternative,
        media_position,
        text_align,
        media_type,
        youtube,
        margins,
        wistia
    } = props.content;

    return (
        media_position === 'right' ? (
        <section className={sectionPaddingClasses(margins)}>
            <div className="container">
                <div className="row">
                    <div className={`col-xs-12 col-md-6 ${text_align && 'text-'+text_align}`}>
                        {title && <h3 className="h3">{title}</h3>}
                        {description && description.length > 0 && RichText.render(description)}
                        {
                            button_url &&
                            button_title &&
                            <a href={button_url} className="btn btn-primary">{button_title}</a>
                        }
                    </div>
                    <div className="col-xs-12 col-md-6">
                        {
                            media_type === 'image' && <img src={image} alt={image_alternative} className="img-fluid" />
                        }
                        {
                            media_type === 'youtube' && <div className="youtube" dangerouslySetInnerHTML={{ __html: youtube.html }} />
                        }
                        {
                            media_type === 'wistia' && <div dangerouslySetInnerHTML={{ __html: wistia }} />
                        }
                    </div>
                </div>
            </div>
        </section>
        ) : (
            <section className={sectionPaddingClasses(margins)}>
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        {
                            media_type === 'image' && <img src={image} alt={image_alternative} className="img-fluid" />
                        }
                        {
                            media_type === 'youtube' && <div className="youtube" dangerouslySetInnerHTML={{ __html: youtube.html }} />
                        }
                        {
                            media_type === 'wistia' && <div dangerouslySetInnerHTML={{ __html: wistia }} />
                        }
                    </div>
                    <div className={`col-xs-12 col-md-6 ${text_align && 'text-'+text_align}`}>
                        {title && <h3 className="h3">{title}</h3>}
                        {description && description.length > 0 && RichText.render(description)}
                        {
                            button_url &&
                            button_title &&
                            <a href={button_url} className="btn btn-primary">{button_title}</a>
                        }
                    </div>
                </div>
            </div>
        </section>
        )

    )
}

SingleMediaSlice.propTypes = {
    content: PropTypes.shape({
        title: PropTypes.string,
        type: PropTypes.string,
        description: PropTypes.arrayOf(PropTypes.object),
        button_title: PropTypes.string,
        button_url: PropTypes.string,
        image: PropTypes.string,
        image_alternative: PropTypes.string,
        media_position: PropTypes.string,
        text_align: PropTypes.string,
        media_type: PropTypes.string,
        youtube: PropTypes.object,
        wistia: PropTypes.string
    })
}



// WEBPACK FOOTER //
// src/client/components/slices/SingleMediaSlice.js